import script from "./KAT.vue?vue&type=script&setup=true&lang=ts"
export * from "./KAT.vue?vue&type=script&setup=true&lang=ts"

import "./KAT.vue?vue&type=style&index=0&id=87fa8822&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87fa8822"]])

export default __exports__